export default __webpack_public_path__ + "static/media/health.159961fa.jpg";